<template>
  <div class="orderMain">
      <top :text="titletext"></top>
      <div v-if="res.orders">
        <div v-bind:key="index" v-for="(item, index) in res.orders">
          <div class="order">
            <div class="orderhead">
              <div>
                订单编号：{{item.order_no}}
              </div>
              <div class="red">
                {{item.current_state.state_detail}}
              </div>
            </div>
            <el-divider></el-divider>
            <div class="classDetail">
              <div class="classDetailImg">
                <img :src="item.order_detail.lecture.thumbnail" alt="">
              </div>
              <div class="classDetailDiv">
                <div>{{item.order_detail.lecture.title}}</div>
                <div class="gray margin">上课地点：{{item.order_detail.place.address}}</div>
                <div class="gray margin">上课日期：{{item.order_detail.day}}</div>
                <div class="gray margin">上课时间：{{item.order_detail.session.start}}-{{item.order_detail.session.end}}</div>
                <div class="num">
                  <div class="red">￥{{item.order_detail.price}}</div>
                  <div class="gray">数量×{{item.order_detail.amount}}</div>
                </div>
              </div>
            </div>
            <el-divider></el-divider>
            <div class="checkButton gray">
              <div :class="item.current_state.state_code =='paid'?'':'none'" @click="toRegistration(item.order_no)">查看报名表</div>
              <div @click="toDetail(item.order_no)">查看详情</div>
              <div :class="item.current_state.state_code =='created'?'':'none'" @click="close(item.order_no)">取消订单</div>
              <div :class="item.current_state.state_code =='paid'?'':'none'" @click="refund(item)">申请退款</div>
              <div :class="item.current_state.state_code =='created'?'':'none'" @click="pay(item.order_no, item.order_detail.total, item.created)">支付订单</div>
            </div>
            <div class="pop">
              <div class="pop1"></div>
              <div class="pop2"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="noneClass">
        目前没有订单
      </div>
    <div style="height: 70px;"></div>
    <sidebar :selected="select"></sidebar>
  </div>
</template>

<script>
import Sidebar from '../components/Sidebar.vue'
import top from '../components/Top.vue'
import http from '../utils/http'

export default {
  name: 'order',
  components: { Sidebar, top },
  data () {
    return {
      checked: false,
      checked1: false,
      titletext: '订单',
      select: 3,
      res: Array
    }
  },
  methods: {
    toDetail: function (id) {
      this.$router.push({name: 'orderDetail', query: {order_no: id}})
    },
    close (id) {
      this.$confirm('确定要取消订单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '我再想想',
        center: true,
        customClass: 'winClass'
      }).then(() => {
        http['post'](`orders/${id}/cancel`).then((res) => {
        })
        http['get']('orders').then((res) => {
          this.res = res
        })
        this.$message({
          type: 'success',
          message: '取消成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '未取消订单'
        })
      })
    },
    refund (item) {
      let mytime = item.current_state.created
      let startTime = `${item.order_detail.day} ${item.order_detail.session.start}`
      let dateTmp = mytime.replace(/-/g, '/')
      let startTmp = startTime.replace(/-/g, '/')
      let timestamp = Date.parse(dateTmp)
      let start = Date.parse(startTmp)
      let newDate = new Date().getTime()
      let ifdate = timestamp - newDate
      ifdate = ifdate + 1000 * 60 * 60 * 24 * 7
      if (newDate > start) {
        this.$confirm('已经过了上课时间，无法申请退单', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          customClass: 'winClass',
          center: true
        })
      } else if (ifdate > 0) {
        this.$prompt('确定要申请退款？报名后7天内可以申请退单，超过7天无法申请退单。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '我再想想',
          center: true,
          customClass: 'winClass',
          inputPlaceholder: '请输入退款理由'
        }).then(({ value }) => {
          http['post'](`orders/${item.order_no}/refund`, {reason: value}).then((res) => {
            http['get']('orders').then((res) => {
              this.res = res
            })
            this.$message({
              type: 'success',
              message: '申请成功!'
            })
          }).catch((e) => {
            this.$message({
              type: 'error',
              message: e.err_msg
            })
          })
          this.$router.go(0)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      } else {
        this.$confirm('报名已经超过7天，无法申请退单', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          customClass: 'winClass',
          center: true
        })
      }
    },
    pay (id, detail, created) {
      this.$router.push({name: 'pay', query: {order_no: id, detail: detail, created: created}})
    },
    toRegistration (order) {
      this.$router.push({name: 'registration', query: {order_no: order}})
    }
  },
  created () {
    http['get']('orders').then((res) => {
      this.res = res
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.orderMain {
  background: #f5f5f5;
  min-height: 40rem;
}
.order {
  margin: 0.8rem;
  border-radius: 10px;
  background: #fff;
}
.orderhead {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
}
.el-divider{
   margin: 0.5rem 0;
}
.classDetail {
  margin-top: 1rem;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
}
.classDetailImg {
  height: 6rem;
  width: 6rem;
  overflow: hidden;
  margin-left: 0.6rem;
}
.classDetailImg img{
  height: 6rem;
  transform: translateX(-50%);
  margin-left: 50%;
}
.classDetailDiv {
  flex: 2;
  margin: 0 0.6rem ;
}
.gray {
  color: #666;
}
.red {
  color: #ff0000;
}
.margin {
  margin: 0.3rem 0;
}
.num {
  display: flex;
  justify-content: space-between;
}
.checkButton {
  display: flex;
  justify-content: flex-end;
}
.none {
  display: none;
}
.checkButton div {
  font-size: 14px;
  border: #999 1px solid;
  border-radius: 27px;
  padding: 0.2rem 0.5rem;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>
<style>
.winClass {
  width: 60%!important;
}
</style>



// WEBPACK FOOTER //
// src/order/order.vue